var _linearGradient, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDashboardRueckmeldung = function SvgDashboardRueckmeldung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117.1 104"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "631-a",
    x1: 58.556,
    x2: 58.556,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF900F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7007"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#631-a)",
    d: "M106.5 104h-96C1.2 104-2.7 97.4 2 89.2l15.5-26.8c5.7-9.8 11.4-19.6 17-29.5L49.9 6.1C54.7-2 62.4-2 67 6.1l15.5 26.8c5.7 9.8 11.4 19.6 17 29.5L115 89.2c4.8 8.2.9 14.8-8.5 14.8z"
  })));
};
export default SvgDashboardRueckmeldung;